import { useEffect, useState, useMemo } from 'react'
import { CartContext } from './CartContext'
import { DEFAULT_CART } from '../../../constants'

export function CartProvider({ children }) {
    const [cart, setCart] = useState({ ...DEFAULT_CART, loading: true })

    useEffect(() => {
        fetch('/api/cart', {
            method: 'GET'
        })
            .then((response) => {
                if (response.status === 200) return response.json()
                console.error('Error loadign cart', response)
                throw new Error('Error loadign cart')
            })
            .then((data) => {
                setCart({ ...data, loading: false })
            })
    }, [])

    const enhancedCart = useMemo(
        () => ({
            ...cart,
            add: async (product_id, qty = 1) => {
                const response = await fetch('/api/cart', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        product_id: Number(product_id),
                        qty: Number(qty)
                        //TODO pass item data such as variations
                    })
                })
                if (response.status !== 200) {
                    //TODO show error messages
                    console.error(response)
                    return
                }
                const newCart = await response.json()
                setCart(newCart)
            },
            update: async (product_id, qty) => {
                const response = await fetch('/api/cart', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        product_id: Number(product_id),
                        qty: Number(qty)
                        //TODO pass item data such as variations
                    })
                })
                if (response.status !== 200) {
                    //TODO show error messages
                    console.error(response)
                    return
                }
                const newCart = await response.json()
                setCart(newCart)
            },
            remove: async (product_id) => {
                const response = await fetch('/api/cart', {
                    method: 'DELETE',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        product_id: Number(product_id)
                    })
                })
                if (response.status !== 200) {
                    //TODO show error messages
                    console.error(response)
                    return
                }
                const newCart = await response.json()
                setCart(newCart)
            },
            clear: async () => {
                const response = await fetch('/api/cart', {
                    method: 'DELETE',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        product_id: 'all'
                    })
                })
                if (response.status !== 200) {
                    //TODO show error messages
                    console.error(response)
                    return
                }
                const newCart = await response.json()
                setCart(newCart)
            },
            get: (product_id) => {
                if (!product_id) return cart?.items || []
                return cart?.items?.find((c) => c.variant_id === product_id) || null
            },
            exists: (product_id) => {
                return typeof cart?.items?.find((c) => c.variant_id === product_id) !== 'undefined'
            },
            variantExists: (variant_id) => {
                return typeof cart?.items?.find((c) => c.variant_id === variant_id) !== 'undefined'
            },
            reset: (cart) => {
                setCart(cart)
            },
            setShipping: async (shippingMethod_id) => {
                console.log('__CART] setting shipping method to '+shippingMethod_id)
                const response = await fetch('/api/cart', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        shippingMethod_id: Number(shippingMethod_id)
                    })
                })
                if (response.status !== 200) {
                    //TODO show error messages
                    console.error(response)
                    return
                }
                const newCart = await response.json()
                setCart(newCart)
            }
        }),
        [cart]
    )

    return <CartContext.Provider value={enhancedCart}>{children}</CartContext.Provider>
}
